import { SorterResult } from 'antd/lib/table/interface'

export function useSorter<T>(sorter?: SorterResult<T> | SorterResult<T>[]): string | undefined {
  if (sorter && !Array.isArray(sorter) && sorter.column) {
    return `${sorter.order == 'descend' ? '-' : ''}${sorter.columnKey}`
  }
}
